<!-- eslint-disable no-unused-vars -->
<script setup>
import { KNOLIA } from "@/knolia"
import { defineEmits, defineProps } from "vue"

const props = defineProps({
  comment: { type: Object, required: true },
  reply: { type: Boolean, default: false },
  repliedComment: { type: Boolean, default: false },
  element: { type: Object, default: () => ({}) },
  validateSkills: { type: Boolean, default: false }
})
const emits = defineEmits(["control-reply", "delete-comment"])

</script>

<template>
  <section :class="{'section-comment': !props.repliedComment, 'section-replied-comment': props.repliedComment, 'comment-right': comment.sender_id == KNOLIA.GetLoggedUserId()}"
    :key="comment.comment_id" :id="`comment${comment.comment_id}`">
    <slot/>
    <header class="header-comment">
      <div class="div-user-header-left">
        <div class="div-user-photo">
          <div class="cover" :style="`background-image: url(${comment.photo_src}), url(${require('@/images/default.png')});`"></div>

        </div>
        <span class="div-user-name">{{ comment.sender_name }}</span>
      </div>
      <div class="d-flex">
          <span class="div-date">{{ comment.date }}</span>
          <i class="fas fa-times close-icon" v-if="reply" @click="emits('control-reply')"></i>
      </div>
    </header>
    <article class="text-area">
      <p class="text" :class="{'deleted': comment.deleted}"> {{ comment.comment }}</p>
      <div class="message-icons" v-if="!props.repliedComment && !reply">
        <div v-if="comment.sender_id == KNOLIA.GetLoggedUserId() && !comment.deleted">
          <i class="fa fa-trash" style="cursor: pointer;" @click="emits('delete-comment', comment.comment_id)"></i>
        </div>
        <div v-show="element.validation_date == null && validateSkills || !validateSkills && !element.waiting_validation">
          <i class="fas fa-reply" style="cursor: pointer;" @click="emits('control-reply', comment)"></i>
        </div>
      </div>
    </article>
  </section>
</template>

<style scoped>

.deleted {
  font-style: italic;
}

.section-comment {
  margin-left: 10px;
}

.section-comment, .section-replied-comment {
  padding: 10px;
  background-color: var(--default-modal-color);
  border-radius: 5px;
  width: 80%;
  box-shadow: -1px 0 10px -2px rgba(0, 0, 0, .35);
}

.section-replied-comment {
  width: 100%;
  cursor: pointer;
  margin-bottom: 10px;
  box-shadow: inset 0px 0px 20px -6px rgba(0, 0, 0, .35);
}

.comment-right {
  align-self: end;
  background-color: var(--default-app-alt-line-color);
  margin-right: 10px;
  margin-left: 0px;
}

.header-comment {
  border-bottom: 1px solid var(--default-font-color);
  display: flex;
  justify-content: space-between;
  padding-bottom: 10px;
}

.close-icon {
  position: relative;
  top: -2px;
  margin-left: 10px;
  cursor: pointer;
}

.text-area {
  display: flex;
  justify-content: space-between;
  margin: 10px 5px 0 5px;
}

.div-user-header-left {
  display: flex;
  align-items: center;
}

.div-user-name {
  font-weight: bold;
}

.text {
  margin: 0;
  text-align: start;
  word-break: break-all;
}

.div-date {
  align-self: center;
}

.message-icons {
  display: flex;
  align-items: flex-end;
  gap: 5px;
}

.cover {
  border-radius: 50%;
  box-sizing: border-box;
  background-size: cover;
  background-position: center;
  width: 25px;
  height: 25px;
}

.div-user-photo {
  margin-right: 5px;
}

.div-user-photo i {
  vertical-align: bottom;
}
</style>
